import { ResizablePanelGroup } from '@art-of-hospitality-solutions-llc/ui-kit/components/resizable';

interface EditorPaneProps {
  children: React.ReactNode;
}

/**
 * The editor's three-pane row (layers | preview | settings) as a resizable
 * panel group. LayerSidebar/PreviewContainer/EditorPanel render the panels;
 * the view places ResizableHandle dividers between them. autoSaveId
 * persists the user's pane widths in localStorage.
 */
export default function EditorPane({ children }: EditorPaneProps) {
  return (
    <ResizablePanelGroup
      direction="horizontal"
      autoSaveId="content-editor.panels"
      className="min-h-0 grow items-stretch"
    >
      {children}
    </ResizablePanelGroup>
  );
}
